"use client";

import Button from "@/components/ui/Button";
import { useTranslations } from "@/i18n/client";
import { useSelection } from "@frend-digital/centra/client";
import AccountInfoForm from "./AccountInfoForm";
import AccountNewsletter from "./AccountNewsletter/AccountNewsletter";
import { ChangePasswordCTA } from "./ChangePasswordCTA";
import styles from "./index.module.css";

const AccountInfo = () => {
  const { data } = useSelection();
  const t = useTranslations();

  if (!data?.loggedIn)
    return <p>{t("myAccount.accountPage.accountInfo.error")}</p>;

  return (
    <div className={styles.detailsContainer}>
      <AccountInfoForm />
      <ChangePasswordCTA />
      <AccountNewsletter
        newsletterTitle="Newsletter"
        newsletterText={t("myAccount.accountPage.accountInfo.newsletter")}
        email={data?.loggedIn.email}
        isUserSignedUp={data?.loggedIn.newsletter}
      />
    </div>
  );
};
export default AccountInfo;

export const AccountInfoPreview = () => {
  const { data } = useSelection();
  const t = useTranslations();

  if (!data?.loggedIn)
    return <p>{t("myAccount.accountPage.accountInfo.error")}</p>;

  return (
    <>
      <div className={styles.accountTitleWrapper}>
        <p className={styles.sectionTitle}>
          {t("myAccount.accountPage.tabs.accountSettings")}
        </p>
        <Button
          className={styles.editAccountButton}
          mode="link"
          href="/account?tab=details"
        >
          Edit account details
        </Button>
      </div>

      <div className={styles.accountInfo}>
        <p>
          {data?.loggedIn.firstName} {data?.loggedIn.lastName}
        </p>
        <p>{data?.loggedIn.email}</p>
        <p>{data?.loggedIn.phoneNumber}</p>
      </div>
    </>
  );
};
